import React from 'react'
import {DealActivityItemBase, DealActivityType} from 'yougile-model'
import {DealTimeLineActivityMessage} from './deal-time-line-activity-message'
import {DealTimeLineCreatedMessage} from './deal-time-line-created-message'
import {DealTimeLineMovedMessage} from './deal-time-line-moved-message'
import {DealTimeLineNoteMessage} from './deal-time-line-note-message'
import {DealTimeLineMessageProps} from './types'

const components: {
  [key in DealActivityType]: React.FC<
    DealTimeLineMessageProps<DealActivityItemBase>
  >
} = {
  created: DealTimeLineCreatedMessage,
  moved: DealTimeLineMovedMessage,
  note: DealTimeLineNoteMessage,
  deal: DealTimeLineActivityMessage
}

export const DealTimeLineMessage = <T extends DealActivityItemBase>({
  activity,
  deal
}: DealTimeLineMessageProps<T>) => {
  // note because for first users we have only note activity
  const Component = components[activity.type ?? 'note']
  if (!Component) {
    return null
  }

  return <Component activity={activity} deal={deal} />
}
